import { type MCPServerInfo } from '../../types';

const FetchServer: MCPServerInfo = {
  serverId: 'FETCH',
  name: 'Fetch',
  slug: 'fetch',
  description:
    'Fetches a URL from the internet and extracts its contents as markdown.',
  source: {
    sourceType: 'REPOSITORY',
    type: 'COMMUNITY',
    repositoryUrl: 'mcp/fetch:latest',
    commitSha: 'latest',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['gpgKey', 'pythonVersion', 'pythonSha256'],
    properties: {
      gpgKey: {
        type: 'string',
        description: 'gpgKey',
        sensitive: true
      },
      pythonVersion: {
        type: 'string',
        description: 'pythonVersion',
        sensitive: false
      },
      pythonSha256: {
        type: 'string',
        description: 'pythonSha256',
        sensitive: false
      }
    }
  },
  deprecated: true
};

export default FetchServer;
